var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiSaleTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    width: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--sale-tag_svg__a",
    height: 14,
    maskUnits: "userSpaceOnUse",
    width: 14,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--sale-tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.017 13.125l-1.109-1.867-2.1-.466.205-2.159L.583 7l1.43-1.633-.205-2.159 2.1-.466L5.018.875 7 1.721 8.983.875l1.109 1.867 2.1.466-.204 2.159L13.417 7l-1.43 1.633.205 2.159-2.1.466-1.109 1.867L7 12.279zm.496-1.488L7 10.996l1.517.641.816-1.4 1.605-.379-.146-1.633L11.87 7l-1.08-1.254.147-1.634-1.605-.35-.845-1.4L7 3.004l-1.517-.642-.816 1.4-1.604.35.145 1.634L2.13 7l1.08 1.225-.146 1.662 1.604.35zm.875-2.566l3.295-3.296-.816-.846-2.48 2.48-1.254-1.226L4.317 7z",
    fill: "#000"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--sale-tag-b766e3bf3b1fec03a48a42e7fcac349d.svg";
export { SvgIconUiSaleTag as Component };